/**
 * Formats a number as a string, abbreviating thousands with "k".
 *
 * For numbers 1000 or greater, returns the value divided by 1000 with up to one decimal place, followed by "k". Trailing ".0" is omitted. Numbers less than 1000 are returned as-is as a string.
 *
 * @param num - The number to format.
 * @returns The formatted string representation of the number.
 *
 * @example
 * formatNumber(950) // "950"
 * formatNumber(1200) // "1.2k"
 * formatNumber(3000) // "3k"
 */
export function formatNumber(num: number): string {
  if (num >= 1000) {
    const formatted = (num / 1000).toFixed(1);
    // Remove trailing .0 if present
    return `${formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted}k`;
  }
  return num.toString();
}
